import { useCallback, useEffect, useState } from 'react'
import { COL_SHIFTS } from '../config/collections'
import { PERMISSION_KEYS } from '../config/permissions'
import { useAuth } from '../context/AuthContext'
import { pb } from '../pocketbase'
import type { ShiftRecord } from '../types/records'

/** Фильтр смены для мастера (только assignedShift) или все смены для admin/manager. */
export function useAssignedShiftFilter() {
  const { user, can } = useAuth()
  const canAllShifts = can(PERMISSION_KEYS.PRODUCTION_SCHEDULE_ALL_SHIFTS)
  const [shiftId, setShiftId] = useState(() =>
    canAllShifts ? '' : (typeof user?.assignedShift === 'string' ? user.assignedShift : ''),
  )
  const [shifts, setShifts] = useState<ShiftRecord[]>([])

  useEffect(() => {
    void pb
      .collection(COL_SHIFTS)
      .getFullList<ShiftRecord>({ sort: 'sort' })
      .then((list) => setShifts(list.filter((s) => s.active)))
      .catch(() => setShifts([]))
  }, [])

  const appendShiftFilter = useCallback(
    (filter: string, field = 'shift') => {
      if (!shiftId) return filter
      return `${filter} && ${field}="${shiftId}"`
    },
    [shiftId],
  )

  return {
    shiftId,
    setShiftId,
    shifts,
    canAllShifts,
    shiftLocked: !canAllShifts,
    appendShiftFilter,
  }
}
